import { type ModalContentProps } from '../../../state';
import { ModalLayout } from '../../layouts';

type Props = ModalContentProps;

const DemoModal = ({ closeModal }: Props) => (
  <ModalLayout closeModal={closeModal} title="Demo Modal">
    Demo
  </ModalLayout>
);

export default DemoModal;
